// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"532":"cbbc5ca724c4e6e21142","691":"96dc37d8088a2f1ad0ea"}[chunkId] + ".js";
};